<template>
	<div class="body" id="pdfDom">
		<div class="header"></div>
		<div class="container">
			<div class="c-wrap">
				<div class="test-bulu">
					<div class="total-title">
						<div>{{ examName }}</div>
						<div>校级分析报告</div>
					</div>
					<div class="total-title-btn" v-on:click="PreviewPage()">预览</div>
					<div class="total-desc">
						<p>
							<span style="font-weight: bold">{{ schoolName }}</span> 本次考试 (考试时间：<span>{{ examTime }}</span> )，
							<span style="font-weight: bold">{{ gradeName }}</span> 共 <span style="font-weight: bold">{{ classNum }}</span> 个班级，<span
								style="font-weight: bold"
								>{{ studentTotalNum }}</span
							>
							名学生参加考试。考试学科：<span style="font-weight: bold">{{ subjectInfo }} {{ subjectNum }}</span> 门学科。
						</p>
						<div>
							<p>
								{{ subjectDesc }}
							</p>
						</div>
					</div>
				</div>
				<div ref="header" class="school-nav">
					<el-menu l-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="selectMenu">
						<el-menu-item v-for="(item, index) in menus" :key="index" :index="index.toString()">{{ item.name }}</el-menu-item>
					</el-menu>
				</div>
				<div class="content-main">
					<!-- 总体情况汇总分析 -->
					<summary-Analysis
						:totalGradeData="[totalGradeData]"
						:subjectGradeData="subjectGradeData"
						:examRange="examRange"
						:exminationData="[exminationData]"
						class="summaryAnalysis"
					/>
					<!-- 总分分布 -->
					<total-Grade-Range class="totalGradeRange" :gradingData="gradingData" :maxScore="maxScore" :minScore="minScore" :avgScore="avgScore" />
					<!-- 总分分档上线人数分布 -->
					<total-Online-People class="totalOnlinePeople" />
					<!-- 分段人数分布 -->
					<subSection-Population class="subSectionPopulation" />
					<!-- 一分三率分析 -->
					<subject-Test-Performance class="subjectTestPerformance" />
					<!-- 等级分析 -->
					<total-Level-Analysis class="totalLevelAnalysis" />
					<!-- 重点学生信息 -->
					<key-Students class="keyStudents" />
				</div>
				<div class="footer">
					<p></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import cookies from '@/utils/cookie'
export default {
	name: 'record',
	components: {
		SummaryAnalysis: () => import('../utils/components/school/SummaryAnalysis'),
		TotalGradeRange: () => import('../utils/components/school/TotalGradeRange'),
		TotalOnlinePeople: () => import('../utils/components/school/TotalOnlinePeople'),
		SubSectionPopulation: () => import('../utils/components/school/SubSectionPopulation'),
		SubjectTestPerformance: () => import('../utils/components/school/subjectTestPerformance'),
		TotalLevelAnalysis: () => import('../utils/components/school/TotalLevelAnalysis'),
		KeyStudents: () => import('../utils/components/school/KeyStudents')
	},
	data() {
		return {
			menus: [
				{
					name: '总体情况汇总',
					className: 'summaryAnalysis'
				},
				{
					name: '总分分布',
					className: 'totalGradeRange'
				},
				{
					name: '总分分档上线人数分布',
					className: 'totalOnlinePeople'
				},
				{
					name: '分段人数分布',
					className: 'subSectionPopulation'
				},
				{
					name: '一分三率分析',
					className: 'subjectTestPerformance'
				},
				{
					name: '等级分析',
					className: 'totalLevelAnalysis'
				},
				{
					name: '重点学生',
					className: 'keyStudents'
				}
			],
			htmlTitle: '校级报表分析',
			classNum: '',
			gradeName: '',
			studentTotalNum: '',
			subjectInfo: '',
			subjectNum: '',
			subjectDesc: '',
			totalGradeData: [],
			subjectGradeData: [],
			exminationData: [],
			activeIndex: '0',
			activeIndex2: '1',
			offsetTop: 0,
			offsetHeight: 0,
			headerFixed: false,
			scrollTopArrs: [],
			clickScrollFlag: false,
			isShowSummary: false,
			maxScore: '',
			minScore: '',
			avgScore: '',
			examTime: '',
			examName: '',
			schoolName: '',
			examRange: 0,
			gradingData: [],
			query: this.$route.query
		}
	},
	created() {
		// this.$screenRation()
		const query = this.$route.query
		cookies.set('token', query.token)
		cookies.set('uuid', 'userId-' + query.userId)
		this.getSummrayData()
	},
	mounted() {
		this.$nextTick(() => {
			// 元素自身的高度
			this.offsetHeight = this.$refs.header.offsetHeight
			// this.getScroll()
			// 监听滚动条
			window.addEventListener('scroll', this.handleScroll)
		})
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		PreviewPage() {
			this.$router.push({
				path: '/report/school/preview',
				query: {
					schoolId: this.query.schoolId,
					examId: this.query.examId
				}
			})
		},
		selectMenu(index) {
			this.getScroll()
			this.clickScrollFlag = true
			this.activeIndex = index.toString()
			document.body.scrollTop = document.documentElement.scrollTop = this.scrollTopArrs[index]
		},
		getSummrayData() {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId
				// examSubjectId: subjeckId
			}
			this.$post('reportApi/selectTotalScoreBase', params).then(res => {
				var resData = res
				if (resData.code === '200') {
					this.examTime = resData.data.examDate
					this.classNum = resData.data.classNum
					this.studentTotalNum = resData.data.totalNum
					this.gradeName = resData.data.gradeName
					this.examName = resData.data.examName
					this.maxScore = resData.data.maxScore.toString()
					this.minScore = resData.data.minScore.toString()
					this.avgScore = resData.data.avgScore.toString()
					this.subjectInfo = resData.data.subjectInfo
					this.subjectNum = resData.data.subjectNum
					this.examRange = resData.data.examRange
					this.subjectDesc = resData.data.describe
					this.totalGradeData = resData.data.tableOptions
					this.subjectGradeData = resData.data.subTableOptions
					this.exminationData = resData.data.regionTableOptions
					this.schoolName = resData.data.schoolName
					this.isShowSummary = true
					this.gradingData = resData.data.gradeTableOptions.reverse()
				}
			})
		},
		getScroll() {
			this.scrollTopArrs = []
			const menuHeight = this.$refs.header.offsetHeight
			for (let item of this.menus) {
				this.scrollTopArrs.push(document.querySelector(`.${item.className}`).offsetTop - menuHeight)
			}
		},
		handleScroll() {
			// 得到页面滚动的距离，兼容写法
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			if (this.clickScrollFlag) {
				if (scrollTop === this.scrollTopArrs[this.activeIndex]) {
					this.clickScrollFlag = false
				}
			} else {
				//当第一次滑动时 当前滚动条的距离小于第一个div盒子的滑动距离，默认给第一个小li激活样式
				if (scrollTop <= this.scrollTopArrs[0]) {
					this.activeIndex = '0'
					return
				}
				//若当前滚动条滑动的距离超过最后一个div盒子所滑动的距离，那么默认给最后一个小li添加样式
				if (scrollTop >= this.scrollTopArrs[this.scrollTopArrs.length - 1]) {
					this.activeIndex = (this.scrollTopArrs.length - 1).toString()
					return
				}
				//第一次滚动条滑动的距离大于第一个div盒子所滑动的距离且小于下一个div盒子所滑动的距离还是给当前的小li默认添加样式，往后以此类推，同理
				for (let i = 0; i < this.scrollTopArrs.length; i++) {
					if (i < this.scrollTopArrs.length && scrollTop >= this.scrollTopArrs[i] && scrollTop < this.scrollTopArrs[i + 1]) {
						this.activeIndex = i.toString()
						return
					}
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
.flip-list-move {
	transition: linear 0.5s;
}
.body {
	margin: 0;
	padding: 0;
	background-color: #eff1f4;
	font-size: 14px;
}
.issFixed {
	width: 1198px;
	margin: 0 auto;
	position: fixed;
	top: 0px;
	left: 0px;
	right: 0px;
	z-index: 4;
}
.school-nav {
	top: 0;
	position: sticky;
	z-index: 10;
	background: #fff;
}

.container {
	width: 100%;
	height: auto;
	.c-wrap {
		width: 1200px;
		height: auto;
		margin: 10px auto;
		box-sizing: border-box;
		.test-bulu {
			position: relative;
			width: 100%;
			height: auto;
			.total-title {
				width: 100%;
				height: 140px;
				color: #fff;
				border-top-left-radius: 5px;
				border-top-right-radius: 5px;
				background-color: #009688;
				overflow: hidden;
				& > div:nth-child(1) {
					margin-top: 40px;
					font-size: 28px;
					text-align: center;
				}
				& > div:nth-child(2) {
					margin-top: 5px;
					font-size: 20px;
					text-align: center;
				}
			}
			.total-title-btn {
				position: absolute;
				top: 50px;
				right: 30px;
				width: 120px;
				height: 34px;
				text-align: center;
				font-size: 12px;
				line-height: 34px;
				background-color: #fff;
				color: #909399;
				border-radius: 20px;
				transition: all 0.2s linear;
				&:hover {
					background-color: #009688;
					color: #fff;
					border: 1px solid #fff;
					cursor: pointer;
				}
			}
			.total-desc {
				width: 100%;
				height: auto;
				background-color: #fff;
				font-size: 14px;
				color: #333;
				border-radius: 2px;
				padding: 20px 30px;
				border-bottom: 1px solid #eee;
				box-sizing: border-box;
				& > p {
					margin-bottom: 10px;
				}
			}
		}
		.school-nav {
			.el-menu-item {
				padding: 0 17.5px;
			}
		}
		.content-main {
			width: 100%;
			height: auto;
			font-size: 14px;
			margin-top: 12px;
		}
		.footer {
			height: 50px;
			margin: 0px auto 10px;
			background-color: #f6f6f6;
			border-radius: 3px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			font-size: 25px;
		}
	}
}
.current {
	border-bottom: 2px solid #409eff;
	transition: linear 0.4s;
}
</style>
